var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
const loaders = [
    {
        filter: () => true,
        request: (source) => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield axios.get(source);
            return result.data;
        })
    }
];
export function registerDoricJSLoader(loader) {
    loaders.push(loader);
}
export function loadDoricJSBundle(source) {
    return __awaiter(this, void 0, void 0, function* () {
        const matched = loaders.filter(e => e.filter(source));
        if (matched.length > 0) {
            return matched[matched.length - 1].request(source);
        }
        throw new Error(`Cannot find matched loader for '${source}'`);
    });
}
//# sourceMappingURL=DoricBundleLoader.js.map